import React, {Component} from 'react'
import { customerCreateByAdmin, customerUpdateByAdmin, sendInviteEmailByAdmin, locationUpdate } from '../../utils/Customer.js'

class CreateAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: props.email,
      formMessage: null,
    }
  }

  getValues() {
    return {
      firstName: document.querySelector('[data-register-firstname]')?.value?.trim(),
      lastName: document.querySelector('[data-register-lastname]')?.value?.trim(),
      acceptsMarketing: document.querySelector('[data-register-marketing]')?.checked,
    }
  }

  updateState(e) {
    const { firstName } = this.getValues()
  }
  submitData() {
    const { firstName, lastName, acceptsMarketing } = this.getValues()
    const submitBtn = document.querySelector('[data-register-submit]')
    submitBtn.disabled = true
    
    customerCreateByAdmin(
      (data) => {
        this.setState({
          formMessage: data?.errors[0]?.message,
        })
        if(data?.errors.length && window.queryCustomer) {
          const prevErrorMsg = data.errors[0].message

          customerUpdateByAdmin(() => {
            },
            { 
              customer: {
                id: window.queryCustomer.id,
                firstName,
                lastName,
              }
            }
          )

          sendInviteEmailByAdmin((data) => {
            if(!data?.errors.length) {
              this.setState({
                formMessage: `${prevErrorMsg}<br />${window.accountStrings.popup.activationEmailSent}`,
              })
              submitBtn.innerHTML = window.accountStrings.popup.invited
            }
          },
          {
            id: window.queryCustomer.id
          })
        } else {
          if(data.customer) {
            submitBtn.innerHTML = window.accountStrings.popup.invited
            sendInviteEmailByAdmin((data) => {
              this.setState({
                formMessage: data?.errors[0]?.message,
              })
              if(!data?.errors.length) {
                this.setState({
                  formMessage: window.accountStrings.popup.confirmationEmailSent,
                })
                submitBtn.innerHTML = window.accountStrings.popup.invited
              }
            },
            {
              id: data.customer.id
            })
          }
        }
        // Send Location data
        setTimeout(() => {
          fetch('//ipinfo.io/json')
            .then(r=>r.json())
            .then(res=> {
              console.log(res)
              if(res && res.country) {
                locationUpdate((data) => {
                  
                  },
                  {
                    email: this.state.email,
                    city: res.city,
                    region: res.region,
                    country_code: res.country,
                  }
                )
              }
            })
        }, 2000)
      },
      {
        customer: Object.assign(
          {
            firstName,
            lastName,
            email: this.state.email,
          }
        , acceptsMarketing ? {
          emailMarketingConsent: {
            // consentUpdatedAt: new Date().toISOString(),
            marketingOptInLevel: 'SINGLE_OPT_IN',
            marketingState: 'SUBSCRIBED',
          }
        } : {}),
      }
    )
  }

  render() {
    return (
      <div className='popup-create-account'>
        <div className="input-wrap mb-10">
          <input type="text" 
            className='' 
            id='RegisterForm-FirstName' 
            placeholder={window.accountStrings.popup.firstName}
            autoComplete="given-name" 
            data-register-firstname 
            onInput={e => this.updateState(e)}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target?.value)
            }}
          />
          <label htmlFor="RegisterForm-FirstName" className=''>
            {window.accountStrings.popup.firstName}
          </label>
        </div>
        <div className="input-wrap mb-10">
          <input type="text" 
            className='' 
            id='RegisterForm-LastName' 
            placeholder={window.accountStrings.popup.lastName}
            autoComplete="family-name" 
            data-register-lastname
            onInput={e => this.updateState(e)}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target?.value)
            }}
          />
          <label htmlFor="RegisterForm-LastName" className=''>
            {window.accountStrings.popup.lastName}
          </label>
        </div>
        <label className="checkbox-wrapper mb-10" htmlFor="marketing">
          <input type="checkbox" name="customer[accepts_marketing]" value="true" id="marketing" data-register-marketing />
          <span className="checkbox-text justify-center">{window.accountStrings.popup.subscribe}</span>
        </label>
        {
          this.state.formMessage && <div className='text-xs mb-10 normal-case' dangerouslySetInnerHTML={{ __html: this.state.formMessage }}></div>
        }
        <button className={`button button--primary w-full mb-10`}
          data-register-submit
          onClick={e => this.submitData()}
        >
          {window.accountStrings.popup.createButton}
        </button>
        
        <div className="normal-case text-fourth-grey text-xs popup-privacy-terms" dangerouslySetInnerHTML={{ __html: window.accountStrings.popup.privacyTerms }} />
      </div>
    )
  }
}

export default CreateAccount